import React, { memo, useCallback, useContext, useEffect, useState } from 'react'

import { Indicator, InputField, InputLocalization, Modal } from '../../../components/common'
import { LanguageContext } from '../../../context/LanguageContext'
import { util } from '../../../util'

const CreatePromo = ({
    modalOpen,
    clearPromoError,
    createPromo,
    close, //close call back was defined in menu component
    modalClose,
    promo_loading,
    user,
    create_promo_error,
}) => {
    const { customerWebLanguages, strings } = useContext(LanguageContext)

    const [promo_name, setPromoName] = useState('')
    const [promoType] = useState([
        { displayName: strings.SECTION_CREATE_NEW_PROMOTION_TYPE_MARKETING, value: 'marketing' },
    ])
    const [localizations, setLocalizations] = useState({ localizations: {} })

    useEffect(() => {
        modalClose && close()
        return () => modalOpen()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalClose])

    /** Function to change the State of the promo name.
     *
     * @param e - event object to track the value entered
     */
    const changeHandler = e => setPromoName(e.target.value)

    /**
     * Function to close modal.
     */
    const cancelModalHandler = useCallback(() => {
        close()
        create_promo_error && clearPromoError()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [create_promo_error])

    /**
     * Function to post newly created promo, if success then navigates to promo details pages.
     */
    const saveClickHandler = () => {
        const type =
            promoType && promoType.length ? promoType.map(type => type['value']) : ['marketing']
        const promoName = util.regexString(promo_name)
        createPromo({
            name: promoName,
            localizations: localizations.localizations,
            type: type,
            created_by: user.email,
        })
    }

    const header = (
        <Modal.Heading
            heading={strings.createPromoHeading}
            cancelModalHandler={cancelModalHandler}
        />
    )

    const content = (
        <div className={'content'}>
            <InputField
                label={strings.NAME_PROMO}
                value={promo_name}
                onChange={changeHandler}
                type={'text'}
                size={'xl'}
                placeholder={strings.createNewPromo}
                required
                name={'create promo'}
                error={create_promo_error}
                className={'create-promo__input-container'}
            />
            <div className={'edit-title-modal__input-localizations py-2'}>
                <InputLocalization
                    fieldKey={'name'}
                    languages={customerWebLanguages.languages}
                    localizations={localizations.localizations}
                    setState={setLocalizations}
                    languageSection={({ index, label, onChange, value }) => (
                        <div key={index} className="py-3">
                            <InputField
                                label={label}
                                value={value}
                                onChange={onChange}
                                type={'text'}
                                size={'xl'}
                                placeholder={strings.createNewPromo}
                                className={'input-localizations__field'}
                                isFullWidth
                            />
                        </div>
                    )}
                />
            </div>
            <div className={'details'}>
                <p className={'details__sub-heading'}>{strings.promoParts}</p>
                <div className={'details__toggles'}>
                    <Indicator
                        size={'sm'}
                        color={'success'}
                        icon={util.FiberManualRecordIcon}
                        label={strings.BREADCRUMB_MARKETING}
                    />
                </div>
            </div>
        </div>
    )

    const modalActions = (
        <Modal.Actions
            color={promo_name.trim() && promo_name.length ? 'primary' : 'disabled'}
            cancelModalHandler={cancelModalHandler}
            saveClickHandler={saveClickHandler}
            submitBtn={strings.SAVE}
            cancelBtn={strings.CANCEL}
            disabledBtn={!promo_name.trim().length || false}
            size={'xl'}
        />
    )

    return (
        <Modal header={header} content={content} actions={modalActions} loading={promo_loading} />
    )
}

export default memo(CreatePromo)
